import { Bundle } from '@spiffcommerce/core'
import { useOnbodyPreview } from '../../hooks/useOnbodyPreview'

export const OnBodyPreview = ({ bundle, setIsLoading }: { bundle: Bundle; setIsLoading: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const { onBodyPreviewStep, toggleOnBodyPreview } = useOnbodyPreview()

  if (!onBodyPreviewStep) return null

  const handleOnBodyPreview = async () => {
    setIsLoading(true)
    await toggleOnBodyPreview(bundle)
    setIsLoading(false)
  }

  return (
    <button className="absolute bottom-6 right-8 flex items-center gap-2.5" onClick={handleOnBodyPreview}>
      <span className="uppercase text-xs">On body preview</span>
      <span>
        <svg width={24} height={15} viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 10.002a2.502 2.502 0 1 0 0-5.005 2.502 2.502 0 0 0 0 5.005Z" stroke="#333132" strokeLinejoin="round" />
          <path
            d="M12 .618c-5.386 0-9.413 4.483-10.767 6.213-.31.397-.31.94 0 1.338C2.586 9.898 6.614 14.38 12 14.38c5.386 0 9.413-4.483 10.767-6.212.31-.398.31-.94 0-1.338C21.413 5.1 17.386.618 12 .618Z"
            stroke="#333132"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  )
}
